import React, { useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  FormLabel,
  Typography,
  Container,
  TableContainer,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import KmFormPreviewTable from "src/components/common/KmFormPreviewTable";
import KmFilteredTable from "src/components/common/KmFilteredTable";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import UserAndDate from "src/components/common/UserAndDate";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CancelIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { apiEndpoints, apiDownloadFileData } from "src/utils/api/api";
import fileDownload from "js-file-download";

const votingStatuses = {
  preparing: "W przygotowaniu",
  canceled: "Anulowane",
  in_progress: "W trakcie",
  finished: "Zakończone",
};

const useStyles = makeStyles((theme) => ({
  root: {},
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(2),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  paddingtopbottom: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  margintop: {
    marginTop: theme.spacing(1),
  },
  toolbarLeftButton: {
    marginRight: theme.spacing(1),
  },
}));

const RowButtons = (row, customHandlers, ...rest) => {
  return (
    <Box>
      <Tooltip title="Anuluj głos">
        <IconButton
          aria-label="anuluj głos"
          onClick={() => customHandlers.cancelVoteHandler(row)}
        >
          <CancelIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const summaryCols = [
  {
    id: "lp",
    label: "L.p.",
    isLp: true,
    isEditable: false,
    sortable: false,
    width: "5%",
  },
  {
    id: "name",
    label: "Odpowiedź",
    fieldName: "name",
    isEditable: false,
    sortable: true,
    width: "85%",
  },
  {
    id: "votesCount",
    label: "Liczba głosów",
    fieldName: "votesCount",
    isEditable: false,
    sortable: true,
    width: "10%",
  },
];

const statusToTabs = {
  preparing: "wprzygotowaniu",
  in_progress: "wtrakcie",
  finished: "zakonczone",
  canceled: "anulowane",
};

const Form = ({
  formReady,
  onSubmit,
  voting,
  votesHistory,
  statusChanges,
  onCancelVote,
  ...rest
}) => {
  const classes = useStyles();
  const [tabNo, setTabNo] = useState(0);
  const [canceledVote, setCanceledVote] = useState(null);
  const [dialogCancelOpen, setCancelOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const cancelVoteHandler = (row) => {
    setCanceledVote(row);
    handleClickCancelVoteOpen(row);
  };

  const userVotesCols = [
    {
      id: "lp",
      label: "L.p.",
      lp: true,
      isEditable: false,
      sortable: false,
      width: "3%",
    },
    {
      id: "username",
      label: "Nazwa użytkownika",
      fieldName: "username",
      isEditable: false,
      sortable: true,
      width: "9%",
    },
    {
      id: "userFirstName",
      label: "Imię",
      fieldName: "userFirstName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userLastName",
      label: "Nazwisko",
      fieldName: "userLastName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userInstitution",
      label: "Instytucja",
      fieldName: "userInstitution",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userFunction",
      label: "Funkcja",
      fieldName: "userFunction",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "votingOptionName",
      label: "Głos",
      fieldName: "votingOptionName",
      isEditable: false,
      sortable: true,
      width: "35%",
    },
    {
      id: "createdAt",
      label: "Data głosowania",
      fieldName: "createdAt",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "createdBy",
      label: "Głos oddany przez",
      fieldName: "createdBy",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "btns",
      kmUdField: false,
      numeric: false,
      disablePadding: false,
      searchable: false,
      sortable: false,
      customHandlers: { cancelVoteHandler },
      component: RowButtons,
    },
  ];

  const userVotesHistoryCols = [
    {
      id: "lp",
      label: "L.p.",
      lp: true,
      isEditable: false,
      sortable: false,
      width: "3%",
    },
    {
      id: "username",
      label: "Nazwa użytkownika",
      fieldName: "username",
      isEditable: false,
      sortable: true,
      width: "9%",
    },
    {
      id: "userFirstName",
      label: "Imię",
      fieldName: "userFirstName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userLastName",
      label: "Nazwisko",
      fieldName: "userLastName",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userInstitution",
      label: "Instytucja",
      fieldName: "userInstitution",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "userFunction",
      label: "Funkcja",
      fieldName: "userFunction",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "votingOptionName",
      label: "Głos",
      fieldName: "votingOptionName",
      isEditable: false,
      sortable: true,
      width: "35%",
    },
    {
      id: "voteStatus",
      label: "Status",
      fieldName: "voteStatus",
      isEditable: false,
      sortable: true,
      dataType: 2,
      dataLabels: { active: "Aktywny", canceled: "Anulowany" },
      width: "10%",
    },
    {
      id: "createdAt",
      label: "Data głosowania",
      fieldName: "createdAt",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "createdBy",
      label: "Głos oddany przez",
      fieldName: "createdBy",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "canceledAt",
      label: "Data anulowania",
      fieldName: "canceledAt",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "canceledBy",
      label: "Anulowane przez",
      fieldName: "canceledBy",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
  ];

  const userVotesStatusChangesCols = [
    {
      id: "lp",
      label: "L.p.",
      lp: true,
      isEditable: false,
      sortable: false,
      width: "5%",
    },
    {
      id: "action",
      label: "Aktywność",
      fieldName: "action",
      isEditable: false,
      sortable: true,
      width: "15%",
      dataType: 2,
      dataLabels: { cancel: "Anulowanie", restore: "Wznowienie", start: "Rozpoczęcie", finish: "Zakończenie", back: "Wycofanie do przygotowania" },
    },
    {
      id: "reason",
      label: "Uzasadnienie",
      fieldName: "reason",
      isEditable: false,
      sortable: true,
      width: "60%",
    },
    {
      id: "createdAt",
      label: "Data zmiany statusu",
      fieldName: "createdAt",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
    {
      id: "createdBy",
      label: "Status zmieniony przez",
      fieldName: "createdBy",
      isEditable: false,
      sortable: true,
      width: "10%",
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabNo(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleClickCancelVoteOpen = () => {
    setCancelOpen(true);
  };

  const handleCancelVoteDialogClose = () => {
    setCancelOpen(false);
  };

  const handleCancelVote = () => {
    setCancelOpen(false);

    onCancelVote(canceledVote);
  };

  const handleExport = () => {
    apiDownloadFileData(
      `${apiEndpoints.getVotingVotesExcel.path}${voting.id}`,
      true
    ).then((result) => {
      fileDownload(result, "Głosy oddane w głosowaniu.xls");
    });
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
      <Container component="main" maxWidth={false}>
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            {voting ? (
              <Box className={classes.paddingtopbottom}>
                <Typography className={classes.paddingtop}>
                  {voting.title}
                </Typography>
              </Box>
            ) : (
              <Skeleton />
            )}
            <AppBar position="static">
              <Tabs
                value={tabNo}
                onChange={handleTabChange}
                aria-label="Szczegóły głosowania"
              >
                <Tab label="Podsumowanie" {...a11yProps(0)} />
                <Tab label="Historia zmian" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <TabPanel value={tabNo} index={0} className={classes.editroot}>
              {voting ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Status
                  </FormLabel>
                  <Typography>
                    {votingStatuses[voting.currentStatus]}
                  </Typography>
                </FormControl>
              ) : (
                <Skeleton />
              )}
              {voting ? (
                <FormControl fullWidth className={classes.formcontrol}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} sm={6}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Data rozpoczęcia
                      </FormLabel>
                      <Typography>{voting.startsAt}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} sm={6}>
                      <FormLabel
                        className={classes.paddingBottom}
                        component="label"
                      >
                        Data zakończenia
                      </FormLabel>
                      <Typography>{voting.endsAt}</Typography>
                    </Grid>
                  </Grid>
                </FormControl>
              ) : (
                <Skeleton />
              )}
              {voting ? (
                <Box className={classes.paddingtopbottom}>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Podsumowanie wyników
                  </FormLabel>
                  <Card className={classes.margintop}>
                    <TableContainer>
                      <KmFormPreviewTable
                        columns={summaryCols}
                        rows={voting.votingOptions}
                      />
                    </TableContainer>
                  </Card>
                </Box>
              ) : (
                <Skeleton />
              )}
              {voting ? (
                <Box className={classes.paddingtopbottom}>
                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.toolbarLeftButton}
                      component={RouterLink}
                      to={`/zarzadzanieglosowania/edycjaglosu/${voting.id}`}
                    >
                      Zagłosuj w imieniu użytkownika
                    </Button>
                    <Button
                      color="secondary"
                      variant="contained"
                      onClick={handleExport}
                      className={classes.toolbarLeftButton}
                    >
                      Eksport głosów
                    </Button>
                  </Box>
                  <FormLabel
                    className={classes.paddingBottom}
                    component="label"
                  >
                    Głosy użytkowników
                  </FormLabel>

                  <KmFilteredTable
                    className={classes.paddingtop}
                    markable={false}
                    headCells={userVotesCols}
                    rows={voting.votes}
                  />
                </Box>
              ) : (
                <Skeleton />
              )}
            </TabPanel>
            <TabPanel value={tabNo} index={1} className={classes.editroot}>
              {voting ? (
                <Box>
                  <FormControl fullWidth className={classes.formcontrol}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} sm={6}>
                        <FormLabel
                          className={classes.paddingBottom}
                          component="label"
                        >
                          Kto i kiedy utworzył
                        </FormLabel>
                        <UserAndDate
                          variant="body1"
                          username={voting.createdBy}
                          date={voting.createdAt}
                          separator=", "
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} sm={6}>
                        <FormLabel
                          className={classes.paddingBottom}
                          component="label"
                        >
                          Kto i kiedy modyfikował
                        </FormLabel>
                        <UserAndDate
                          variant="body1"
                          username={voting.updatedBy}
                          date={voting.updatedAt}
                          separator=", "
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                  <FormControl fullWidth className={classes.formcontrol}>
                    <FormLabel
                      className={classes.paddingBottom}
                      component="label"
                    >
                      Historia głosów użytkowników
                    </FormLabel>

                    <KmFilteredTable
                      className={classes.paddingtop}
                      markable={false}
                      headCells={userVotesHistoryCols}
                      rows={votesHistory}
                    />
                  </FormControl>

                  <FormControl fullWidth className={classes.formcontrol}>
                    <FormLabel
                      className={classes.paddingBottom}
                      component="label"
                    >
                      Historia ręcznych zmian statusu głosowania
                    </FormLabel>

                    <KmFilteredTable
                      className={classes.paddingtop}
                      markable={false}
                      headCells={userVotesStatusChangesCols}
                      rows={statusChanges}
                    />
                  </FormControl>
                </Box>
              ) : (
                <Skeleton />
              )}
            </TabPanel>

            <Box className={classes.paddingtopbottom}>
              <Button
                color="primary"
                className={classes.button}
                component={RouterLink}
                to={`/zarzadzanieglosowania/${
                  voting && statusToTabs[voting.currentStatus]
                    ? statusToTabs[voting.currentStatus]
                    : "wprzygotowaniu"
                }`}
              >
                Zamknij
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        fullScreen={fullScreen}
        open={dialogCancelOpen}
        onClose={handleCancelVoteDialogClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Anulowanie głosu"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography paragraph>
              Czy na na pewno chcesz anulować głos użytkownika "
              {canceledVote ? canceledVote.username : "-"}"?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleCancelVoteDialogClose}
            color="primary"
          >
            Nie
          </Button>
          <Button onClick={handleCancelVote} color="primary" autoFocus>
            Tak
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default Form;
